import { currentAppBrand } from '@b2ag/app-brands'

export function getPartnerLogoUrl(cloudinaryBucketName: string, partnerId: number) {
  return `https://res.cloudinary.com/${cloudinaryBucketName}/image/upload/h_140,w_140,c_pad,q_auto,f_auto,dpr_auto/logos/partners/${currentAppBrand}/partner_${+partnerId}`
}
